import moment from "moment-timezone";

const NoTzFormat = "YYYY-MM-DDTHH:mm:ss";
const TzByLang = {
  "en-US": "America/New_York",
  "es-LA": "America/New_York",
  "en-GB": "Europe/London"
};

/**
 * Strips a given date's timezone, using local timezone instead
 * @param date - Date to convert
 * @return {Date} - Moment date with local timezone
 */
export const forceConvertLocalTime = (date) => moment(date.format(NoTzFormat), NoTzFormat);

/**
 * Accessor for timezones by lang.
 * @param lang - Lang string
 * @return {String} - Timezone string
 */
export const getTzWithLang = (lang) => TzByLang[lang];




// WEBPACK FOOTER //
// ./public/utils/time.js